module.exports = __webpack_public_path__ + "img/callmac.a355692e.png";